import React from 'react';
import Navbar from '../components/Navbar';
import ChatbotButton from '../components/ChatbotButton';
import '../styles/profile.css';
import { FaUserEdit, FaLink, FaCog } from 'react-icons/fa';

const ProfilePage = () => {
  return (
    <div className="profile-container">
      <Navbar />
      <div className="profile-content">
        <img
          src="https://cdn-icons-png.flaticon.com/512/9131/9131529.png"
          alt="Profile"
          className="profile-image"
        />
        <h2>Ali Al-Lamki</h2>
        <p className="phone-number">+968 96358008</p>

        <div className="profile-options">
          <div className="option-box">
            <FaUserEdit />
            <span>Edit Profile</span>
          </div>
          <div className="option-box">
            <FaLink />
            <span>Linked Accounts</span>
          </div>
          <div className="option-box">
            <FaCog />
            <span>Settings</span>
          </div>
        </div>
      </div>

      <ChatbotButton />
    </div>
  );
};

export default ProfilePage;
